console.log(1)

function routers () {
  console.log(2)
}


export default routers



// WEBPACK FOOTER //
// ./src/util.js